import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SubService } from './sub.service';
import { SubjectService } from './subject-services';
import { StorageService } from './storage.service';
@Injectable()
export class LoaderService {
  private loaderSubject = new Subject();
  public loader_status:boolean=false;
  loaderState = this.loaderSubject.asObservable();
  constructor(
    public sub: SubService,
    private subject: SubjectService,
     public storage: StorageService
     
  ) { }
  show() {
    this.loaderSubject.next({ show: true });
  }
  hide() {

    if(this.storage.get('report_submit')!==undefined){
      this.loader_status=this.storage.get('report_submit');
    }
    if(this.loader_status){
     this.subject.listen().subscribe((data: any = {}) => {
            if (data.for == "progress_handle") {
                 this.loaderSubject.next({ show: false });
                 console.log("pop")
            }
           
        })
    }else{
      setTimeout(() => {
        this.loaderSubject.next({ show: false });
      }, 300);
    }
      
  }
}
